import { createOidcAuth, SignInType, LogLevel } from '@data42/vue-oidc-client/vue2'
import log from 'loglevel'
import { AccessType } from '@mymsa/common'

import { getEnv } from './utilities'

export const SELECTED_MEMBER_KEY = 'mymsa:selectedMember'

const appUrl = new URL(window.location.origin).toString()
const oidcConfig = {
  authority: getEnv('VUE_APP_OIDC_AUTHORITY'),
  client_id: getEnv('VUE_APP_OIDC_CLIENT_ID'),
  response_type: 'code',
  scope: 'openid profile email phone msa',
  loadUserInfo: false,
  automaticSilentRenew: true,
  post_logout_redirect_uri: null,
  popupWindowFeatures: getPopupWindowFeatures()
}
const auth = createOidcAuth({
  authName: 'main',
  defaultSignInType: SignInType.Popup,
  fallbackSignInType: SignInType.Window,
  appUrl,
  oidcConfig,
  logger: log,
  logLevel: LogLevel.Debug
})

// Clear default access token expired event to prevent opening login popup on access token expired.
// This is so the user can be prompted to sign in again or sign out.
// Also prevents this bug from happening: https://github.com/soukoku/vue-oidc-client/issues/75
clearAuthEventHandlers()
auth.events.addAccessTokenExpired(onAccessTokenExpired)

function clearAuthEventHandlers () {
  for (const eventHandler of auth.events._accessTokenExpired._callbacks) {
    auth.events.removeAccessTokenExpired(eventHandler)
  }
}

function onAccessTokenExpired () {
  log.debug(`${auth.authName} auth token expired`)

  // Perform same behaviour as access token expired handler in oidc-client-js without trying to sign in again automatically.
  auth.user = null
}

export function isStaffOrAdmin () {
  if (!auth.isAuthenticated) return false
  const accessType = auth.userProfile.access_type ?? ''
  return [AccessType.ADMINISTRATOR, AccessType.STAFF].includes(accessType)
}

export function isElevated () {
  if (!auth.isAuthenticated) return false
  const accessType = auth.userProfile.access_type ?? ''
  return [AccessType.ADMINISTRATOR, AccessType.STAFF, AccessType.AUS_MEAT].includes(accessType)
}

// Helper function to render the login popup in the center of the screen
function getPopupWindowFeatures () {
  const popupWidth = 550
  const popupHeight = 800
  const popupOffsetLeft = Math.floor(window.innerWidth / 2) - Math.floor(popupWidth / 2)
  const popupOffsetTop = Math.floor(window.innerHeight / 2) - Math.floor(popupHeight / 2)
  return `location=no,toolbar=no,width=${popupWidth},height=${popupHeight},left=${popupOffsetLeft},top=${popupOffsetTop};`
}

export default auth
